<template>
  <div>
    <!--
    <div class="a11y-vista-simplificada container text texto-intro m-y-5">
      <p>En esta sección se encuentra la galería fotográfica de la región.</p>
      <p>Para visualizarla, es necesario desactivar la vista simplificada.</p>
    </div>
    -->
    <div class="">
      <div class="container text texto-intro m-y-2-lg m-y-1-sm">
        <h1>Galería</h1>
      </div>

      <grid-galeria class="container main m-y-2-lg m-y-1-sm a11y-simplificada-block" >
        <img-galeria
          v-for="(datum, i) in lista_imagenes_seleccionadas"
          :key="i"
          :ruta_imgs="'galeria_seleccionada/' + datum.nombre_archivo"
          @click.native="
            fijaIndice(i);
            $refs.modal_galeria.abrirModal();
          "
          :anio="datum.anio"
        />
      </grid-galeria>

      <modal
        ref="modal_galeria"
        :posicion_boton="'arriba'"
        :max_ancho="'1200px'"
        max_alto="100vh"
      >
        <template v-slot:cuerpo>
          <Carousel
            :id="'carrusel_1'"
            :lista="lista_modal"
            :indice_seleccionado="indice_foto_seleccionada"
          />
        </template>
      </modal>

      <!--La parte de los albumes -->
      <div class="container m-b-3">
        <h2 class="m-t-3">Álbumes fotográficos</h2>
        <hr />
        <div class="grid-albumes">
          <EnlaceAlbum
            link="https://1drv.ms/u/s!Aubg4PSdkCoihEh0PGOXbW4jwYcB?e=nAvA1Y"
            imagen_lap="galeria_seleccionada/laguna-xalapango.png"
            imagen_cel="galeria_seleccionada/laguna-xalapango-mobile.png"
            titulo="Laguna de Xalapango"
          />
          <EnlaceAlbum
            link="https://1drv.ms/u/s!Aubg4PSdkCoihEdM2FkcXQDXqSBB?e=lVZWMC"
            imagen_lap="galeria_seleccionada/nabor-carrillo.png"
            imagen_cel="galeria_seleccionada/nabor-carrillo-mobile.png"
            titulo="Nabor Carrillo"
          />
          <EnlaceAlbum
            link="https://1drv.ms/u/s!Aubg4PSdkCoihEve2ZhMfpJBXIyE?e=27KDXO"
            imagen_lap="galeria_seleccionada/cerro-huatepec.png"
            imagen_cel="galeria_seleccionada/cerro-huatepec-mobile.png"
            titulo="Cerro de Huatepec"
          />
          <EnlaceAlbum
            link="https://1drv.ms/u/s!Aubg4PSdkCoihErEBdIV4dio65-s?e=Yj9j4b"
            imagen_lap="galeria_seleccionada/cienega-san-juan.png"
            imagen_cel="galeria_seleccionada/cienega-san-juan-mobile.png"
            titulo="Ciénega de San Juan"
          />
          <EnlaceAlbum
            link="https://1drv.ms/u/s!Aubg4PSdkCoihEnRO6BKD5vC2efs?e=3YIy3z"
            imagen_lap="galeria_seleccionada/colector-marginal.png"
            imagen_cel="galeria_seleccionada/colector-marginal-mobile.png"
            titulo="Colector marginal"
          />
          <EnlaceAlbum
            link="https://1drv.ms/u/s!Aubg4PSdkCoihEZ1hMEGE2E3h7B5?e=ggyLqc"
            imagen_lap="galeria_seleccionada/zona-federal.png"
            imagen_cel="galeria_seleccionada/zona-federal-mobile.png"
            titulo="Zona Federal Lago de Texcoco"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";

import gridGaleria from "@/components/galeria/grid-galeria.vue";
import imgGaleria from "@/components/galeria/img-galeria.vue";
import Modal from "@/components/base/Modal.vue";
import Carousel from "@/components/base/Carousel.vue";
import EnlaceAlbum from "@/components/galeria/enlace-album.vue";

export default {
  name: "Galeria",
  components: {
    gridGaleria,
    imgGaleria,
    Modal,
    Carousel,
    EnlaceAlbum,
  },
  data: function () {
    return {
      lista_imagenes: [],
      opciones: ["Todas las fotografías"],
      lista_imagenes_seleccionadas: [],
      categoria_seleccionada: "Todas las fotografías",
      lista_modal: [],
      altura: "auto",
    };
  },
  mounted() {
    if (document.getElementById("initial-loader")) {
      document.getElementById("initial-loader").remove();
      document.getElementsByTagName("body")[0].style.overflow = "visible";
    }

    d3.csv("data/base_galeria.csv").then((data) => {
      this.lista_imagenes = data;
      this.opciones = this.opciones.concat([
        ...new Set(data.map((d) => d.categoria)),
      ]);
      this.lista_imagenes_seleccionadas = this.lista_imagenes;
      console.log(this.lista_imagenes_seleccionadas);
      this.lista_modal = this.lista_imagenes_seleccionadas.map((d) => [
        "galeria_seleccionada/" + d.nombre_archivo,
        d.categoria,
        d.anio,
        d.categoria + ", " + d.anio,
      ]);
    });
  },
  watch: {
    categoria_seleccionada() {
      if (this.categoria_seleccionada == "Todas las fotografías") {
        this.lista_imagenes_seleccionadas = this.lista_imagenes;
      } else {
        this.lista_imagenes_seleccionadas = this.lista_imagenes.filter(
          (d) => d.categoria == this.categoria_seleccionada
        );
      }
      this.lista_modal = this.lista_imagenes_seleccionadas.map((d) => [
        "galeria_seleccionada/" + d.nombre_archivo,
        d.categoria,
        d.anio,
        d.categoria + ", " + d.anio,
      ]);
    },
  },
  methods: {
    fijaIndice(i) {
      this.indice_foto_seleccionada = i;
    },
  },
};
</script>

<style  lang="scss">
#selector-categoria-fotos {
  width: 100%;
}
.modal {
  &-encabezado {
    position: relative !important;
    padding-bottom: 0;
    button.btn-icono.icono-cerrar.modal-cerrar {
      line-height: 0.3;
      margin-top: 10px;
    }
  }
}

.grid-albumes {
  display: grid;
  grid-gap: $gap;
  grid-template-columns: repeat(1, 1fr);

  @media (min-width: map-get($media-queries-since, "md")) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: map-get($media-queries-since, "lg")) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: map-get($media-queries-since, "xl")) {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
